import loadable from '@loadable/component';
import { Loader } from '@/components';

export const AsyncPSD2Approved = loadable(() => import('./PSD2Approved'), {
  fallback: <Loader />,
});
